module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "product-donate-duration-wrapper"
  }, [_c('div', {
    staticClass: "duration-heading"
  }, [_vm._v(_vm._s(_vm.headingLabel))]), _vm._v(" "), _c('fieldset', {
    staticClass: "sr-only-legend-wrapper"
  }, [_c('legend', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.headingLabel))]), _vm._v(" "), _c('div', {
    staticClass: "product-donate-duration"
  }, _vm._l((_vm.options), function(opt) {
    return _c('div', {
      key: opt.value,
      staticClass: "donate-duration-item"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.selected),
        expression: "selected",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "id": ("duration-" + (opt.value)),
        "type": "radio",
        "name": "donation_duration"
      },
      domProps: {
        "value": opt.value,
        "checked": _vm._q(_vm.selected, _vm._n(opt.value))
      },
      on: {
        "change": function($event) {
          _vm.selected = _vm._n(opt.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "label",
      class: {
        'label--selected': _vm.selected === opt.value
      },
      attrs: {
        "for": ("duration-" + (opt.value))
      }
    }, [_vm._v("\n            " + _vm._s(opt.label) + "\n          ")])])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0cf2eac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0cf2eac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDuration.vue
// module id = 766
// module chunks = 1